import axios from "axios";

const REACT_APP_MANAGE_USERS = process.env.REACT_APP_MANAGE_USERS;

export const getRolesByRadioID = (params) => (dispatch) => {
  axios
    .get(`${REACT_APP_MANAGE_USERS}/roles/product`, params)
    .then((res) => {
      dispatch({
        type: "GET_ROLES_SUCCESS_BY_RADIO_ID",
        payload: res.data.data,
      });
    })
    .catch((err) => {
      if (err.response?.data.message) {
        dispatch({
          type: "GET_ROLES_BY_RADIO_ID_FAIL",
          payload: err.response.data.message,
        });
      }
    });
};
export const getUserList = (params) => (dispatch) => {
  axios
    .get(
      `${REACT_APP_MANAGE_USERS}/users/product?per_page=${params.perPage}&page=${params.page}`,
      params
    )
    .then((res) => {
      dispatch({
        type: "GET_USERS_SUCCESS",
        payload: res.data?.data.data,
        params,
      });
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "GET_USERS_FAIL",
          payload: err.response.data.message,
        });
      }
    });
};
export const getUsersByRoleID = (role_id, params) => (dispatch) => {
  axios
    .get(
      `${REACT_APP_MANAGE_USERS}/users/role/${role_id}/product?page=${params.page}`,
      params
    )
    .then((res) => {
      dispatch({
        type: "GET_USERS_BY_ROLE_ID",
        payload: res.data.data,
        params,
      });
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "GET_USERS_BY_ROLE_FAIL",
          payload: err.response.data.message,
        });
      }
    });
};
